import { render, staticRenderFns } from "./DetailIndex.vue?vue&type=template&id=1bd874a2&scoped=true"
import script from "./DetailIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DetailIndex.vue?vue&type=style&index=0&id=1bd874a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd874a2",
  null
  
)

export default component.exports